export function load_sprites(k){

k.loadSprite("image_background", "sprites/background/background.png")
k.loadSprite("omori", "sprites/omori.png")
k.loadSprite("omori_right", "sprites/omori_right.png");
k.loadSprite('barraTareas', "sprites/environment/barraTareas.png")
k.loadSprite('mewo', "sprites/mewo-sprite.png", {
    sliceX: 2,
    sliceY: 1,
    anims: {
        idle: { from: 0, to: 1, loop: true, speed: 0.6 }
    }
})

k.loadSprite("aubrey_sheet", "sprites/DW_AUBREY_2test.png", {
    sliceX: 12,
    sliceY: 8,
    anims: {
        idle_down: { from: 48, to: 48 }
    }
})

k.loadSprite("omori_sheet", "sprites/DW_OMORI.png", {
    sliceX: 12,
    sliceY: 8,
    anims: {
        idle_down: { from: 1, to: 1 },
        walk_down: { from: 0, to: 2, loop: true },
        idle_left: { from: 13, to: 13 },
        walk_left: { from: 12, to: 14, loop: true },
        idle_right: { from: 25, to: 25 },
        walk_right: { from: 24, to: 26, loop: true },
        idle_up: { from: 37, to: 37 },
        walk_up: { from: 36, to: 38, loop: true },
    }
});

k.loadFont("pixelFonts", "fonts/04B_03__.TTF")
}